import axios from "axios";
import {
  CREATE_CUSTOMER,
  DELETE_CUSTOMER,
  EDIT_CUSTOMER,
  ENABLE_DISABLE_CUSTOMER,
  GET_CUSTOMER,
  GET_CUSTOMER_DETAILS,
} from "../../constants/ApiConstant";
import { ToastMessage } from "../../utils/Helper";
import { optionsDialCode } from "../../constants";

/**
 * get Customer list data
 * @param {paganization params} paramsObj
 * @returns data response
 */

export const get_Customer = (paramsObj) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .get(`${process.env.REACT_APP_API_URL}${GET_CUSTOMER}`, {
      headers: {
        Authorization: jwt_token,
      },
      params: paramsObj,
    })
    .then((res) => res.data);
};

/**
 * add Customer api call
 * @param {form data} formData
 * @returns
 */

export const Create_Customer = (formData) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .post(`${process.env.REACT_APP_API_URL}${CREATE_CUSTOMER}`, formData, {
      headers: { Authorization: jwt_token },
    })
    .then((message) => {
      return message;
    })
    .catch((error) => {
      const { status, message } = error?.response?.data || error;
      ToastMessage(status, message);
    });
};

/**
 *enable - disable Customer api call
 * @param {form data as isActive & customerId} formData
 * @param {list api call function} refetch
 * @returns true & false
 */

export const Enable_Disable_Customer = (formData, refetch) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .put(
      `${process.env.REACT_APP_API_URL}${ENABLE_DISABLE_CUSTOMER}`,
      formData,
      {
        headers: { Authorization: jwt_token },
        params: { customerId: formData.customerId },
      }
    )
    .then((message) => {
      refetch();
      ToastMessage(message.status, message.data.message);
    })
    .catch((error) => {
      if (error.response) {
        const { status, message } = error?.response?.data || error;
        ToastMessage(status, message);
      }
    });
};

export const Get_Details_Customer = (customerId, setFormData, setdialogs) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .get(`${process.env.REACT_APP_API_URL}${GET_CUSTOMER_DETAILS}`, {
      headers: { Authorization: jwt_token },
      params: { customerId },
    })
    .then(async (res) => {
      let data = res.data.payload.data;
      let dialCode = optionsDialCode.find(
        (elem) => elem.code === data.dialCode
      );
      setFormData({
        name: data?.name ?? null,
        email: data?.email ?? null,
        dialCode: dialCode ?? null,
        mobile: data?.mobile ?? null,
        wpGroupId: data?.wpGroupId ?? null,
        enableForGeneralPost: data?.enableForGeneralPost ?? null,
        squareFrameImage: data?.squareFrameImage ?? null,
        verticalFrameImage: data?.verticalFrameImage ?? null,
        companyId: data?.companyId ?? null,
        customerId: data?.customerId ?? null,
      });
      setdialogs(true);
    });
};

/**
 * update Customer api call
 * @param {form data} formData
 * @param {*} customerId
 * @returns
 */

export const Put_Update_Customer = (formData, customerId) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .put(`${process.env.REACT_APP_API_URL}${EDIT_CUSTOMER}`, formData, {
      headers: { Authorization: jwt_token },
      params: { customerId },
    })
    .then((message) => {
      return message;
    })
    .catch((error) => {
      const { status, message } = error?.response?.data || error;
      ToastMessage(status, message);
    });
};

/**
 * delete Customer api call
 * @param {form data} formData
 * @param {*} customerId
 * @param {list api call } refetch
 * @returns
 */

export const DELETE_Customer = (customerId, refetch) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .delete(`${process.env.REACT_APP_API_URL}${DELETE_CUSTOMER}`, {
      headers: { Authorization: jwt_token },
      params: { customerId },
    })
    .then((message) => {
      refetch();
      ToastMessage(message.status, message.data.message);
    })
    .catch((error) => {
      const { status, message } = error?.response?.data || error;
      ToastMessage(status, message);
    });
};

export const Get_Details__Customer = (paramObj) => {
  const jwt_token = localStorage.getItem("authToken");
  return axios
    .get(`${process.env.REACT_APP_API_URL}${GET_CUSTOMER_DETAILS}`, {
      headers: { Authorization: jwt_token },
      params: paramObj,
    })
    .then(async (res) => {
      return res.data.payload.data;
    });
};
